<p-dialog
  [header]="'objects.wizard.updateImpact.title' | transloco"
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="!loading()"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '32rem' }"
  (onHide)="onClose()"
>
  <ng-container *transloco="let t">
    @if (loading()) {
      <div class="flex justify-center items-center p-6">
        <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }" />
      </div>
    } @else if (impact()) {
      <div class="flex flex-column gap-3">
        @if (hasBlockingWarnings()) {
          <p-message severity="error" [text]="t('objects.wizard.updateImpact.blockedMessage')" />

          <div class="flex flex-column gap-2">
            <span class="font-semibold impact-section-title impact-section-title--blocking">
              {{ t('objects.wizard.updateImpact.blockingTitle') }}
            </span>
            @for (warning of blockingWarnings(); track warning.type) {
              <div class="impact-card impact-card--blocking">
                <i class="pi pi-exclamation-triangle impact-card__icon impact-card__icon--blocking"></i>
                <span class="impact-card__message">{{ warning.message }}</span>
              </div>
            }
          </div>
        }

        @if (safeWarnings().length > 0) {
          @if (!hasBlockingWarnings()) {
            <p-message severity="warn" [text]="t('objects.wizard.updateImpact.warningMessage')" />
          }

          <div class="flex flex-column gap-2">
            <span class="font-semibold impact-section-title impact-section-title--info">
              {{ t('objects.wizard.updateImpact.infoTitle') }}
            </span>
            @for (warning of safeWarnings(); track warning.type) {
              <div class="impact-card impact-card--info">
                <i class="pi pi-info-circle impact-card__icon impact-card__icon--info"></i>
                <span class="impact-card__message">{{ warning.message }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'objects.wizard.updateImpact.goBack' | transloco"
        severity="secondary"
        [outlined]="true"
        (onClick)="onClose()"
        [disabled]="loading()"
      />
      @if (canProceed()) {
        <p-button
          [label]="'objects.wizard.updateImpact.proceed' | transloco"
          severity="warn"
          (onClick)="onProceed()"
          [disabled]="loading()"
        />
      }
    </div>
  </ng-template>
</p-dialog>
